import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#about',
    label: 'About',
    type: 'anchor' as const
  }, {
    href: '#immersive-experience',
    label: 'Experience',
    type: 'anchor' as const
  }, {
    href: '#creators',
    label: 'Creators',
    type: 'anchor' as const
  }, {
    href: '/treasure',
    label: 'Treasury',
    type: 'route' as const
  }, {
    href: '/restore-punjab',
    label: 'Restore Punjab',
    type: 'route' as const
  }, {
    href: '/sikh-heritage-forward',
    label: 'Sponsor',
    type: 'route' as const
  }, {
    href: '#event-details',
    label: 'Get There',
    type: 'anchor' as const
  }];
  return <motion.nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6
  }} data-id="element-1826" data-mp="jksw6aryi7lf">
      <div className="container mx-auto px-4" data-id="element-1827" data-mp="vmfsuemxs2s">
        <div className="flex items-center justify-between h-20" data-id="element-1828" data-mp="uuss7z3t2o4">
          {/* Logo */}
          <a href="#hero" className="text-white font-serif text-xl tracking-wider" data-id="element-1829" data-mp="5ofg9632me92">
            SIKH KINGDOMS
          </a>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12" data-id="element-1830" data-mp="39aejaz8e46zh">
            {navLinks.map(link => link.type === 'route' ? <Link key={link.href} to={link.href} className="text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase font-light" data-id="element-1831" data-mp="2wcgdug7mmuy4">
                  {link.label}
                </Link> : <a key={link.href} href={link.href} className="text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase font-light" data-id="element-1832" data-mp="2ibvunixsux43">
                  {link.label}
                </a>)}
          </div>
          {/* Mobile menu button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white" data-id="element-1833" data-mp="2ndl9zas21wxz">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-1834" data-mp="2krh78o3411f" /> : <Menu className="w-6 h-6" data-id="element-1835" data-mp="a495ezc9xf4b" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      <AnimatePresence data-id="element-1836" data-mp="f4wydqk2c616">
        {isMobileMenuOpen && <motion.div className="md:hidden bg-black border-t border-white/10" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} data-id="element-1837" data-mp="1441iz6agyuw">
            <div className="container mx-auto px-4 py-8 space-y-6" data-id="element-1838" data-mp="xwhazj3sw3sy">
              {navLinks.map(link => link.type === 'route' ? <Link key={link.href} to={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase" data-id="element-1839" data-mp="o3s0orjzkvz7">
                    {link.label}
                  </Link> : <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-white/70 hover:text-amber-400 transition-colors text-sm tracking-wider uppercase" data-id="element-1840" data-mp="3k341niunjbcn">
                    {link.label}
                  </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
};